import { IonHeader, IonTitle, IonToolbar } from "@ionic/react";
import React from "react";

export const PageHeader = (props: any) => {
  const safeArea = props.safeArea !== undefined ? props.safeArea : true;
  const size = props.size || "large";
  const collapse = props.collapse || "condense";

  return (
    <IonHeader collapse={collapse} className={safeArea ? "ion-padding-safe-area-top" : ""}>
      <IonToolbar>
        <IonTitle
          size={size}
          style={{
            paddingInline: 0,
            textAlign: "left",
          }}
        >
          {props.children}
        </IonTitle>
      </IonToolbar>
    </IonHeader>
  );
};
